import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import PasswordlessModal from './PasswordlessModal';

import {
    setPasswordlessEmailStatus as setPasswordlessEmailStatusAction,
    sendPasswordlessEmail as sendPasswordlessEmailAction,
} from '../../actions/passwordless';

import { clearAuthNotification as clearAuthNotificationAction } from '../../actions/auth';

import {
    trackOpenPasswordlessModal as trackOpenPasswordlessModalAction,
    trackClosePasswordlessModal as trackClosePasswordlessModalAction,
} from '../../actions/gaTracking';

import { LOG_IN_FORM } from '../../constants';

const _mapStateToProps = (state) => {
    const { status, social } = state;
    const { socialData: { apple, facebook, google } = {} } = social;

    const previousFormEmail =
        formValueSelector(LOG_IN_FORM)(state, 'email') ||
        apple?.email ||
        facebook?.email ||
        google?.email;

    return {
        passwordlessEmailStatus: status.passwordlessEmailStatus,
        previousFormEmail,
    };
};

const _mapDispatchToProps = {
    handleSendPasswordlessLink: sendPasswordlessEmailAction,
    setPasswordlessEmailStatus: setPasswordlessEmailStatusAction,
    trackOpenPasswordlessModal: trackOpenPasswordlessModalAction,
    trackClosePasswordlessModal: trackClosePasswordlessModalAction,
    clearAuthNotification: clearAuthNotificationAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(PasswordlessModal);
